import { createContext, useContext } from "react";

export const FlowFormContext = createContext(null);

export const useFlowForm = () => useContext(FlowFormContext);

